import type { Variant } from 'components/Toolkit/Inputs/types';
import { ListSingleSelectOption } from 'components/SearchPage/components/Filters/ListSingleSelect/ListSingleSelect';
import { RadioTabs } from 'components/Toolkit/Inputs/RadioTabs';

export interface IListSingleSelectTagProps {
  name: string;
  label: string;
  value: string;
  options: ListSingleSelectOption[];
  onChange: (value: string) => void;
  styleVariant?: Variant;
  className?: string;
}

function ListSingleSelectTag(props: IListSingleSelectTagProps) {
  const {
    options,
    label,
    name,
    styleVariant = 'COMFORT',
    className,
    onChange,
    value,
  } = props;
  return (
    <>
      {options && (
        <RadioTabs
          value={value}
          name={name}
          onChange={onChange}
          tabLabel={label}
          options={options.map(({ value, label }) => ({
            value,
            displayValue: label,
          }))}
          variant={styleVariant}
          className={className}
        />
      )}
    </>
  );
}

export { ListSingleSelectTag };
